import type React from 'react';
import { BORDERS, TYPOGRAPHY } from '../../../constants/design';
import { useColors, useTheme } from '../../../contexts/ThemeContext';
import { COLOR_PALETTES } from '../../../utils/colorUtils';

interface IconWithBackgroundProps {
  icon: React.ReactNode;
  color: string;
}

export const IconWithBackground: React.FC<IconWithBackgroundProps> = ({ icon, color }) => {
  const tokens = useColors();
  const { theme } = useTheme();
  const palette = COLOR_PALETTES[color as keyof typeof COLOR_PALETTES];
  const primaryColor = palette?.[500] || color;

  // Light mode: use palette[50] from design system
  // Dark mode: subtle transparent mix over dark background
  const lightBg = palette?.[50] || tokens.primary[50];
  const darkBg = `color-mix(in srgb, ${primaryColor} 14%, ${tokens.surface.layout})`;
  // Use theme hook directly instead of checking color value
  const bgColor = theme === 'dark' ? darkBg : lightBg;

  return (
    <div
      style={{
        width: '32px',
        height: '32px',
        borderRadius: BORDERS.radius.md,
        background: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <span style={{ color: primaryColor, fontSize: TYPOGRAPHY.fontSize.md }}>{icon}</span>
    </div>
  );
};
